import { createReducer, on } from '@ngrx/store';
import { setComisionAction } from './comision.actions';


export const initialState = 0;

export const comisionReducer = createReducer(
  initialState,
  on(setComisionAction, (state, { comision }) => comision)
);